import React, { useEffect, useRef, useState } from "react";
import MainHeading from "../../../components/comman/MainHeading";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import moment from "moment";
import CommonTable from "../../../components/comman/CommonTable";
import FilterComponent from "../../../components/comman/FilterComponent";
import { useDispatch, useSelector } from "react-redux";
import { updateFiltersStates } from "../../../store/actions/UserActions";

export default function DebitNote() {
  const dispatch = useDispatch();
  const timeoutId = useRef(null);
  const userDetails = useSelector((state) => state.root.userDetails);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    debitNoteList: [],
    searchQuery: "",
    siteId: filterDetails?.siteId,
    siteList: [],
    companyList: [],
    companyIsLoading: false,
    isLoadingSite: false,
    isInitial: true,
  });

  useEffect(() => {
    if (filterDetails?.year) {
      GetDebitNoteList();
    }
    if (pageStates?.companyList?.length == 0) {
      GetCompanyList();
    }
  }, [
    filterDetails?.currentPage,
    pageStates?.searchQuery,
    filterDetails?.pageSize,
    filterDetails.sortByDate,
    filterDetails?.year,
    filterDetails?.siteId,
    filterDetails?.companyId,
    filterDetails?.orderBy,
    pageStates?.isInitial,
  ]);

  useEffect(() => {
    GetSiteList(filterDetails?.companyId);
  }, [filterDetails?.companyId]);

  const GetDebitNoteList = () => {
    let options = {
      method: "GET",
    };
    let Url =
      apiUrl.get_transaction +
      "?type=debitNote&" +
      MainFilterHandler({
        ...filterDetails,
        siteId: pageStates?.siteId,
        searchQuery: pageStates?.searchQuery,
      });
    setPageStates((pre) => ({
      ...pre,
      tableLoader: !pre.tableLoader,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      if (res?.status === true) {
        const newData = res?.data?.transaction?.map((item) => ({
          ...item,
          dateOfTransaction:
            moment(item?.transactionDate).format("DD-MM-YYYY") || "",
          siteName: item?.site?.name || "",
          invoiceNumber: item?.invoice?.invoiceNumber || "",
        }));
        setPageStates((pre) => ({
          ...pre,
          debitNoteList: newData,
          countsData: { ...res?.data?.counts },
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${
        inputValue ? `?search=${inputValue}` : ""
      }`;
      let options = { method: "GET" };
      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        pageSize: value,
      })
    );
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      dispatch(updateFiltersStates({ currentPage: 1 }));
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 300);
  };

  const TableHeading = [
    { value: "index", label: "Sr No." },
    { value: "transactionId", label: "Debit Note no." },
    { value: "invoiceNumber", label: "Invoice no." },
    { value: "siteName", label: "Site" },
    { value: "dateOfTransaction", label: "Transaction Date" },
    { value: "amount", label: "Amount " },
    { value: "remark", label: "Remark" },
  ];

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
            `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${
              searchQuery ? `&search=${searchQuery}` : ""
            }`
          : apiUrl.get_user_site +
            `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${
              searchQuery ? `&search=${searchQuery}` : ""
            }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const sortList = {
    site: pageStates?.siteList,
    isShow: "show",
    companyList: pageStates?.companyList,
  };

  const handleSortData = (data, type) => {
    setPageStates((prevState) => ({
      ...prevState,
      ...(type === "site" && { siteId: data?.site }),
      ...(type === "companyId" && { companyId: data?.companyId }),
      ...(type == "companyId" && {
        siteId: "",
      }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
        ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
      })
    );
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      dispatch(
        updateFiltersStates({
          sortByDate: formattedDate,
        })
      );
    } else {
      dispatch(
        updateFiltersStates({
          sortByDate: "",
        })
      );
    }
  };

  const handleYearChange = (selectedYear) => {
    dispatch(
      updateFiltersStates({
        year: selectedYear,
        sortByDate: isFirstYearChange ? filterDetails.sortByDate : [],
      })
    );

    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Debit Note"}
          dateChangeHandler={dateChangeHandler}
          handleYearChange={handleYearChange}
        />

        <div className="card mb-4">
          <div className="card-body">
            <FilterComponent
              filterArray={sortList}
              handleSearch={handleSearchChange}
              handleData={handleSortData}
              pageStates={pageStates}
              orderByHandler={orderByHandler}
              orderByList={orderByList}
              getSite={GetSiteList}
              getCompany={GetCompanyList}
            />
            <CommonTable
              TableHeading={TableHeading}
              TableData={pageStates?.debitNoteList}
              currentPage={filterDetails?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={filterDetails?.totalPages}
              count={filterDetails?.count}
              handleChangePageSize={handleChangePageSize}
              pageSize={filterDetails?.pageSize}
            />
          </div>
        </div>
      </div>
    </>
  );
}
